import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge, Col, Tab, Nav, OverlayTrigger, Tooltip } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Consumption from '../../../modal/Purchase_Management/Manage_Stocks/Consumption';
import ConsumptionHistory from '../../../modal/Purchase_Management/Manage_Stocks/Consumption_His';
import ConsumptionReturn from '../../../modal/Purchase_Management/Manage_Stocks/ConsumptionReturn';
import ResolveReason from '../../../modal/Purchase_Management/Manage_Stocks/StockchecklistReason'; 
import KitchenRoomModal from '../../../modal/Stock_Management/general/KitchenRoomModal';
import StockWastageModal from '../../../modal/Stock_Management/general/StockWastageModal';
import StockWastageListModal from '../../../modal/Stock_Management/general/StockWastageListModal';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import Select from 'react-select';
import bgimage from '../../../../images/items/items.jpg';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';


const Stock = () => {
    const onInit = () => {};

    const [open, setOpen] = useState(false);
    const [modalType, setModalType] = useState(""); 
    const [key, setKey] = useState('manage_stock'); 
    const [stockData, setStockData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [storageRooms, setStorageRooms] = useState([]);
    const [selectedRoom, setSelectedRoom] = useState(null);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const baseURL = process.env.REACT_APP_API_BASE_URL;
 

    // // Fetch stock data
    // const fetchStockData = (roomId = null) => {
    //     setLoading(true);
    //     let url = `${baseURL}/manage-stock`;
    //     if (roomId) url += `?stock_room=${roomId}`;

    //     fetch(url)
    //         .then(res => res.json())
    //         .then(data => {
    //             setStockData(data.data || []);
    //             setLoading(false);
    //         })
    //         .catch(err => {
    //             console.error(err);
    //             setStockData([]);
    //             setLoading(false);
    //         });
    // };


    // Fetch stock data from backend
    const fetchStockData = async () => {
        setLoading(true);
        try {
            let url = `${baseURL}/manage-stock?page=${page}&per_page=${perPage}`;
            if (searchTerm) url += `&search=${encodeURIComponent(searchTerm)}`;
            if (selectedRoom) url += `&stock_room=${selectedRoom}`;

            const res = await fetch(url);
            const data = await res.json();

            if (data.data) {
                setStockData(data.data);
                setTotalEntries(data.pagination.total);
                setTotalPages(data.pagination.last_page);
            } else {
                setStockData([]);
                setTotalEntries(0);
                setTotalPages(1);
            }
        } catch (err) {
            console.error(err);
            setStockData([]);
            setTotalEntries(0);
            setTotalPages(1);
        }
        setLoading(false);
    };


    // Fetch storage rooms
    const fetchStorageRooms = () => {
        fetch(`${baseURL}/storageroom/active/list`)
            .then(res => res.json())
            .then(data => {
                const rooms = data.data?.map(r => ({ value: r.sno, label: r.storageroom_name })) || [];
                setStorageRooms(rooms);
            })
            .catch(err => console.error(err));
    };

    // Initial fetch
    useEffect(() => {
        fetchStockData();
        fetchStorageRooms();
    }, []);

    // Fetch on storage room change
    useEffect(() => {
        fetchStockData(selectedRoom?.value || null);
    }, [selectedRoom]);

    const getDaysAgo = (dateString) => {
        if (!dateString) return null;
        const consumedDate = new Date(dateString);
        const today = new Date();
        const diffTime = today - consumedDate;
        return Math.floor(diffTime / (1000 * 60 * 60 * 24));
    };

    const formatNumber = (value) => {
        const num = Number(value);
        return isNaN(num) ? '0.00' : num.toFixed(2);
    };

        const [selecteddata, setSelecctedData] = useState({});
    const handleModalToggle_History = (data) => {
        setSelecctedData(data);
        setModalType("ConsumptionHistory");  // Set the modal type to "Add"
        setOpen(true);
    };

function formatNumbers(value) {
    if (value === null || value === undefined || value === '') return '';
    return parseFloat(value).toString(); 
}


    return (
        <>
            {/* Page Header */}
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                {/* <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Stocks</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Purchase Management</li>
                    </ol>
                </div> */}
                   {loading ? (
                        <> 
                            <div className="mb-0">
                                <div className="mb-0 px-0">
                                    <Skeleton width={220} height={28} />
                                </div>
    
                                <ol className="breadcrumb fs-7">
                                    <li className="breadcrumb-item"><Skeleton width={100} height={18} /></li>
                                    <li className="breadcrumb-item"><Skeleton width={40} height={18} /></li>
                                    <li className="breadcrumb-item"><Skeleton width={140} height={18} /></li>
                                </ol>
                            </div>
    
                        
                        </>
                    ) : (
                        <> 
                            <div className="mb-0">
                                <div className="mb-0 px-0">
                                    <h4 className="breadcrumb-header">Manage Stocks</h4>
                                </div>
                                <ol className="breadcrumb fs-7">
                                    <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                                    <li className="breadcrumb-item active">Stock Management</li>
                                </ol>
                            </div>
    
                            
                        </>
                    )}
 
                {/* Buttons */}
                   {/* <Link to='/stocks-verification' className="btn btn-primary btn-sm">
                        <span className='me-2'><i className="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                        <span>Stock Verification</span>
                    </Link>    */}

                <div className="d-flex align-items-center gap-2">
                 


                    {loading ? (
                        <>
                            <Skeleton width={130} height={30} />
                            <Skeleton width={120} height={30} />
                            <Skeleton width={120} height={30} />
                        </>
                    ) : (
                        <>
                            <Link to='/stocks-checklist' className="btn btn-primary btn-sm">
                                <span className='me-2'><i className="fa-solid fa-list-check fs-8"></i></span>
                                <span>Stock Checklist</span>
                            </Link>

                           

                            <Button className="btn btn-success btn-sm" onClick={() => {
                                setModalType("StockWastage");
                                setOpen(true);
                            }}>
                                <span className='me-2'> </span>
                                <span>+ Add Wastage</span>
                            </Button>
                        </>
                    )} 
                </div>
                 
                {open && modalType === "KitchenRoom" && (
                    <KitchenRoomModal show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "StockWastage" && (
                    <StockWastageModal show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "StockWastageList" && (
                    <StockWastageListModal show={open} onClose={() => setOpen(false)} />
                )}

                {open && modalType === "ConsumptionHistory" && (
                    <ConsumptionHistory show={open} onClose={() => setOpen(false)} data={selecteddata} />
                )}
                {open && modalType === "Consumption" && <Consumption show={open} onClose={() => setOpen(false)} />}
                {/* {open && modalType === "ConsumptionHistory" && <ConsumptionHistory show={open} onClose={() => setOpen(false)} />} */}
                {open && modalType === "Consumption_return" && <ConsumptionReturn show={open} onClose={() => setOpen(false)} />}           
                {open && modalType === "resolve_reason" && <ResolveReason show={open} onClose={() => setOpen(false)} />}
            </div>

            {/* Stock Table */}
            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={setKey}>
                   
                        <Nav as="ul" className="nav-tabs align-items-center">
                            {loading ? (
                                <div className="d-flex w-100 justify-content-between align-items-center py-2"> 
                                    <Skeleton width={150} height={35} /> 
                                    <div className="d-flex gap-2">
                                        <Skeleton width={300} height={35} />
                                        <Skeleton width={80} height={35} />
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <Nav.Item as="li">
                                        <Nav.Link eventKey="manage_stock">
                                            <i className="fa-regular fa-user me-2" />
                                            <label className="ms-2 fs-6">Manage Stock</label>
                                        </Nav.Link>
                                    </Nav.Item>

                                    <div className="ms-auto d-flex align-items-center gap-2">
                                        <Select
                                            options={storageRooms}
                                            value={selectedRoom}
                                            onChange={setSelectedRoom}
                                            placeholder="Select Storage Room"
                                            className="stock-room-dropdown"
                                            styles={{ container: base => ({ ...base, width: 300 }) }}
                                        />
                                        <Button
                                            size="sm"
                                            variant="secondary"
                                            onClick={() => {
                                                setSelectedRoom(null);
                                                fetchStockData();
                                            }}
                                        >
                                            Clear
                                        </Button>
                                    </div>
                                </>
                            )}
                        </Nav>
 
                        <Tab.Content className="pt-4">
                            <Tab.Pane eventKey="manage_stock">
                                <div className="table-container">

                                    <div className="d-flex justify-content-between align-items-center mb-3">  
                                        <div>
                                            {loading ? (
                                                <> 
                                                    <Skeleton width={40} height={12} className="mb-1" />
                    
                                                    <Skeleton width={70} height={30} />
                                                </>
                                            ) : (
                                                <>
                                                    <label className="me-2">Show</label>
                                                    <select
                                                        className="form-select d-inline w-auto"
                                                        style={{ fontSize: '0.85rem', height: '30px' }}
                                                        value={perPage}
                                                        onChange={(e) => {
                                                            setPerPage(Number(e.target.value));
                                                            setPage(1);
                                                        }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={25}>25</option>
                                                        <option value={50}>50}</option>
                                                        <option value={100}>100</option>
                                                    </select>
                                                </>
                                            )}
                                        </div>
                
                                          <div>
                                                {loading ? (
                                                    <Skeleton width={150} height={40} />
                                                ) : (
                                                    <input
                                                        type="text"
                                                        style={{ fontSize: '0.85rem', height: '40px' }}
                                                        placeholder="Search..."
                                                        className="form-control"
                                                        value={searchTerm}
                                                        onChange={(e) => {
                                                            setSearchTerm(e.target.value);
                                                            setPage(1);
                                                        }}
                                                    />
                                                )}
                                            </div>
                                    </div>

                                    <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                            {loading ? (
                                                <tr>
                                                    <th><Skeleton width={90} height={12} /></th>
                                                    <th><Skeleton width={120} height={12} /></th>
                                                    <th className="text-center"><Skeleton width={80} height={12} /></th>
                                                    <th><Skeleton width={150} height={12} /></th>
                                                    <th className="text-center"><Skeleton width={90} height={12} /></th>
                                                    <th className="text-center"><Skeleton width={100} height={12} /></th> 
                                                </tr>
                                            ) : (
                                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                    <th>Raw Material</th>
                                                    <th>Brand / Expiry Day</th>
                                                    <th className='text-center'>Current Stock</th>
                                                    <th className='text-center'>Buy Date / Qty</th>
                                                    <th className='text-center'>Consumption Qty / Day</th>
                                                    <th className='text-center'>Stock Level</th> 
                                                </tr>
                                            )}
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7">
                                            {loading ? (
                                                // Skeleton rows while loading
                                                [...Array(5)].map((_, index) => (
                                                    <tr key={index}>
                                                        {/* Raw Material + Stock Room */}
                                                        <td>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <Skeleton circle width={45} height={45} />
                                                                <div>
                                                                    <Skeleton width={120} height={14} className="mb-1" />
                                                                    <Skeleton width={80} height={12} />
                                                                </div>
                                                            </div>
                                                        </td>

                                                        {/* Brand + Expiry */}
                                                        <td align="center">
                                                            <Skeleton width={60} height={20} className="mb-1" />
                                                            <Skeleton width={50} height={12} />
                                                        </td>

                                                        {/* Current Stock */}
                                                        <td align="center">
                                                            <Skeleton width={60} height={14} />
                                                        </td>

                                                        {/* Purchased Date + Quantity */}
                                                        <td align="center">
                                                            <Skeleton width={80} height={20} className="mb-1" />
                                                            <Skeleton width={60} height={12} />
                                                        </td>

                                                        {/* Consumed Date + Quantity */}
                                                        <td align="center">
                                                            <Skeleton width={80} height={20} className="mb-1" />
                                                            <Skeleton width={60} height={12} />
                                                        </td>

                                                        {/* Stock Level */}
                                                        <td align="center">
                                                            <Skeleton width={50} height={20} />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : stockData.length > 0 ? (
                                                // Actual data
                                                stockData.map(stock => (
                                                    <tr key={stock.sno}>
                                                        {/* Raw Material + Stock Room */}
                                                        <td>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                                    <div data-src={stock.image_url || bgimage} className='border rounded px-1 py-0'>
                                                                        <img src={stock.image_url || bgimage} alt={stock.rawmaterial_name} className='cursor-pointer w-45px h-45px' />
                                                                    </div>
                                                                </LightGallery>
                                                                <div>
                                                                    <label className='text-black fs-7'>{stock.rawmaterial_name}</label>
                                                                    <div className="d-block">
                                                                        <label className="fs-8 text-primary fw-bold">{stock.stock_room_name}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        {/* Brand + Expiry */}
                                                        <td align='center'>
                                                            <Badge bg="info" className='text-white fs-7'>{stock.brand || '-'}</Badge>
                                                            <div className='d-block mt-1'>
                                                                <label className='text-black fs-7'>{stock.expiry_period || '-'} Days</label>
                                                            </div>
                                                        </td>

                                                        {/* Current Stock */}
                                                        <td align='center'>
                                                            <label className='text-black fs-7'>{formatNumbers(stock.current_stock)} {stock.current_stock_unit_slug}</label>
                                                        </td>

                                                        {/* Purchased Date + Qty */}
                                                        <td align='center'>
                                                            <Badge bg="none" className='fw-semibold fs-7 text-danger border border-danger'>
                                                                {stock.purchased_date
                                                                    ? new Date(stock.purchased_date).toLocaleDateString('en-GB', {
                                                                        day: '2-digit',
                                                                        month: 'short',
                                                                        year: 'numeric'
                                                                    })
                                                                    : '-'}
                                                            </Badge>
                                                            <div className='d-block mt-1'>
                                                                <label className='text-black fs-7'>
                                                                    {formatNumbers(stock.purchased_qty)} {stock.unit}
                                                                </label>
                                                            </div>
                                                        </td>

                                                        {/* Consumed Date + Qty */}
                                                        <td align='center'>
                                                            {stock.consumed_date ? (
                                                                <Badge bg="none" className="fw-semibold fs-7 text-primary border border-primary">
                                                                    {new Date(stock.consumed_date).toLocaleDateString('en-GB', {
                                                                        day: '2-digit',
                                                                        month: 'short',
                                                                        year: 'numeric'
                                                                    })}
                                                                </Badge>
                                                            ) : (
                                                                <Badge bg="none" className="fw-semibold fs-7 text-primary border border-primary">-</Badge>
                                                            )}
                                                            <div className='d-block mt-1'>
                                                                <label className='text-black fs-7'>{formatNumbers(stock.consumed_qty)} {stock.consumed_unit_slug}</label>
                                                            </div>
                                                        </td>

                                                        {/* Stock Level */}
                                                        <td align="center">
                                                            {stock.stock_level_status === 0 && <Badge bg="warning" className="text-white fs-7 py-0 px-1">Available</Badge>}
                                                            {stock.stock_level_status === 1 && <Badge bg="danger" className="text-white fs-7 py-0 px-1">Low</Badge>}
                                                            {stock.stock_level_status === 2 && <Badge bg="success" className="text-white fs-7 py-0 px-1">High</Badge>}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center">No records found.</td>
                                                </tr>
                                            )}
                                        </tbody>

                                       
                                     


                                    </table>

                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                                            
                                                                {/* Bottom left: Showing x to y of z entries */}
                                                                <div>
                                                                    {loading ? (
                                                                        <Skeleton width={200} height={16} />
                                                                    ) : (
                                                                        stockData.length > 0 ? (
                                                                            <span className="text-muted">
                                                                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + stockData.length} of {totalEntries} entries
                                                                            </span>
                                                                        ) : (
                                                                            <span className="text-muted">
                                                                                Showing 0 to 0 of 0 entries
                                                                            </span>
                                                                        )
                                                                    )}
                                                                </div>
                                        
                                                                {/* Bottom right: Pagination */}
                                                                <nav>
                                                                    {loading ? (
                                                                        <div className="d-flex gap-1">
                                                                            {[...Array(5)].map((_, i) => (
                                                                                <Skeleton key={i} width={30} height={30} />
                                                                            ))}
                                                                        </div>
                                                                    ) : (
                                                                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                                            {/* Previous Button */}
                                                                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                                                    Previous
                                                                                </button>
                                                                            </li>
                                        
                                                                            {/* First Page */}
                                                                            <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                                                    1
                                                                                </button>
                                                                            </li>
                                        
                                                                            {/* Left Ellipsis */}
                                                                            {page > 4 && (
                                                                                <li className="page-item disabled">
                                                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                                                </li>
                                                                            )}
                                        
                                                                            {/* Pages Around Current */}
                                                                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                                                .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                                                .map(p => (
                                                                                    <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                                                            {p}
                                                                                        </button>
                                                                                    </li>
                                                                                ))}
                                        
                                                                            {/* Right Ellipsis */}
                                                                            {page < totalPages - 3 && (
                                                                                <li className="page-item disabled">
                                                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                                                </li>
                                                                            )}
                                        
                                                                            {/* Last Page */}
                                                                            {totalPages > 1 && (
                                                                                <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                                                        {totalPages}
                                                                                    </button>
                                                                                </li>
                                                                            )}
                                        
                                                                            {/* Next Button */}
                                                                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                                                    Next
                                                                                </button>
                                                                            </li>
                                                                        </ul>
                                                                    )}
                                                                </nav>
                                        
                                    </div>
                                </div>



                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>
        </>
    );
}

export default Stock;
